













import Vue from 'vue';
import TableTrainings from '@/components/TableTrainings.vue';
import TrainingDetail from '@/components/TrainingDetail.vue';

export default Vue.extend({
  name: 'Trainings',
  components: {
    TableTrainings,
    TrainingDetail,
  },
  data: () => ({
    login: '',
    password: '',
  }),
  methods: {},
});
